import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const columns = [{
  title: 'Practice',
  links: [{
    label: 'Executive Search',
    to: '/employers'
  }, {
    label: 'Board & Advisory',
    to: '/employers'
  }, {
    label: 'Leadership Assessment',
    to: '/employers'
  }, {
    label: 'Interim Leadership',
    to: '/employers'
  }]
}, {
  title: 'Candidates',
  links: [{
    label: 'Browse Opportunities',
    to: '/opportunities'
  }, {
    label: 'Career Insights',
    to: '/insights'
  }, {
    label: 'Your Dashboard',
    to: '/dashboard'
  }, {
    label: 'Submit Your Profile',
    to: '/opportunities'
  }]
}, {
  title: 'Firm',
  links: [{
    label: 'Manage Your Firm',
    to: '/firm'
  }, {
    label: 'Your Dashboard',
    to: '/dashboard'
  }, {
    label: 'Insights',
    to: '/insights'
  }, {
    label: 'Contact',
    to: '/employers'
  }]
}];
export function Footer() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  return <footer className="bg-ink text-ivory-200" data-id="element-226" data-mp="2kb0b9q1v7f1h">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-227" data-mp="2p4341vytikgm">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-228" data-mp="2bcexe87c8o71">
          <div className="lg:col-span-4" data-id="element-229" data-mp="2bdzp7q29pt17">
            <Link to="/" className="flex items-center gap-3" data-id="element-230" data-mp="2gbj4mtapcbuq">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold text-gold" data-id="element-231" data-mp="2gbrgqiz03d4v">
                <span className="font-serif text-lg leading-none" data-id="element-232" data-mp="33yzor8ntd0al">A</span>
              </span>
              <span className="flex flex-col leading-none" data-id="element-233" data-mp="380l4d1rqfsoh">
                <span className="font-serif text-lg tracking-wide text-ivory-100" data-id="element-234" data-mp="2u1uyoxqukkoi">
                  Ardent
                </span>
                <span className="text-[10px] uppercase tracking-widest2 text-gold" data-id="element-235" data-mp="2z069baoyuz7s">
                  Executive Search
                </span>
              </span>
            </Link>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-ink-400" data-id="element-236" data-mp="1nnnc80s6163r">
              A global partner to boards and leaders — placing exceptional people in the
              roles that shape the future.
            </p>
            <form className="mt-8" onSubmit={e => {
            e.preventDefault();
            if (email) setSent(true);
          }} data-id="element-237" data-mp="zl8rqtq636xn">
              <label htmlFor="footer-email" className="text-xs uppercase tracking-widest2 text-gold" data-id="element-238" data-mp="pt2tx3d8hvaj">
                Leadership Briefing
              </label>
              {sent ? <p className="mt-3 text-sm text-ivory-100" data-id="element-239" data-mp="bta3781pjf2k">
                  Thank you — you’re subscribed.
                </p> : <div className="mt-3 flex items-center border-b border-ink-500 focus-within:border-gold transition-colors" data-id="element-240" data-mp="6w1j31x010yo">
                  <input id="footer-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email" className="w-full bg-transparent py-2 text-sm text-ivory-100 placeholder:text-ink-400 focus:outline-none" data-id="element-241" data-mp="265i2exl2ai45" />
                  <button type="submit" aria-label="Subscribe" className="p-2 text-gold transition-transform hover:translate-x-1" data-id="element-242" data-mp="2ngx4y3vk349z">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-243" data-mp="1urzlvyjit3g6" />
                  </button>
                </div>}
            </form>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8 lg:pl-10" data-id="element-244" data-mp="1zprhp3nad9pn">
            {columns.map(col => <div key={col.title} data-id="element-245" data-mp="23ql57vwtgmi0">
                <h3 className="text-xs uppercase tracking-widest2 text-gold" data-id="element-246" data-mp="3b799d4rleivt">
                  {col.title}
                </h3>
                <ul className="mt-5 space-y-3" data-id="element-247" data-mp="3f6i3wbugiksf">
                  {col.links.map(link => <li key={link.label} data-id="element-248" data-mp="3drfom8lnpvro">
                      <Link to={link.to} className="text-sm text-ink-400 transition-colors hover:text-ivory-100" data-id="element-249" data-mp="38rugp8oied2t">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-ink-700 pt-8 sm:flex-row sm:items-center" data-id="element-250" data-mp="iawzgfhdhcw">
          <p className="text-xs text-ink-400" data-id="element-251" data-mp="aaqfceuow7yb">
            © {new Date().getFullYear()} Ardent Executive Search. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-ink-400" data-id="element-252" data-mp="5bvz9ko3wxhw">
            <a href="#" className="transition-colors hover:text-ivory-100" data-id="element-253" data-mp="ja3u9n1l1oqf">
              Privacy
            </a>
            <a href="#" className="transition-colors hover:text-ivory-100" data-id="element-254" data-mp="fal7smu455lh">
              Terms
            </a>
            <a href="#" className="transition-colors hover:text-ivory-100" data-id="element-255" data-mp="xy3ufftzgtjp">
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>;
}